module.exports = __webpack_public_path__ + "assets/img/cus11.e1b8c705.jpg";